module.exports = __webpack_public_path__ + "img/2.94070f58.png";